module.exports = __webpack_public_path__ + "static/img/7.bae97e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/7.png
// module id = A/X2
// module chunks = 0